var _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _circle4, _circle5, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.7698,
    y1: 23.0417,
    x2: 17.0168,
    y2: 18.6376,
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8599,
    y1: 15.0336,
    x2: 10.1587,
    y2: 9.86603,
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.67427,
    y1: 22.4269,
    x2: 11.8435,
    y2: 19.667,
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.6588,
    y1: 13.6408,
    x2: 16.3288,
    y2: 16.4501,
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.69949,
    cy: 23.672,
    r: 2.5,
    transform: "rotate(-86.6335 6.69949 23.672)",
    stroke: "#E44E4E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4387,
    cy: 11.5167,
    r: 2.5,
    transform: "rotate(-86.6335 21.4387 11.5167)",
    stroke: "#E44E4E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.63558,
    cy: 7.81704,
    r: 2.5,
    transform: "rotate(-86.6335 9.63558 7.81704)",
    stroke: "#E44E4E",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6667,
    cy: 24.7877,
    r: 2.5,
    transform: "rotate(-86.6335 25.6667 24.7877)",
    stroke: "#E44E4E",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5682,
    cy: 17.6236,
    r: 3,
    transform: "rotate(-86.6335 14.5682 17.6236)",
    stroke: "#DF3030",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 5,
    x2: 28,
    y2: 5,
    stroke: "#E44E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkFee);
export default __webpack_public_path__ + "static/media/networkFee.f81de79945416b12b54d1da702cb5b0d.svg";
export { ForwardRef as ReactComponent };